/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiARewindForwardIcon16Solid = forwardRef('MediaUiARewindForwardIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 9.444v2.514c0 1.06 1.201 1.674 2.061 1.053l5.345-3.86a1.42 1.42 0 0 0 0-2.302l-5.345-3.86C9.201 2.368 8 2.982 8 4.043v2.513L3.061 2.989C2.201 2.368 1 2.982 1 4.043v7.915c0 1.06 1.201 1.674 2.061 1.053L8 9.445Z" })));
});
